import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, orderBy } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ClienteDeClienteEdit } from "./edit";
const EditModal = ClienteDeClienteEdit;
type Entity = models.ClienteDeClienteDTO;
type Column = kea.Grid2Column<Entity>;

export interface Props {
    idCliente: number;
    readonly?: boolean;
}

export interface BotonesDeps {
    onEliminar: (item: Entity) => void;
}

function botones(deps: BotonesDeps): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([
        {
            tooltip: "Eliminar",
            style: "danger",
            iconClass: fa("trash"),
            onClick: deps.onEliminar
        }
    ]);

    return {
        ...columna,
        cell: x => ({
            ...columna.cell(x),
            style: () => ({
                maxWidth: "300px"
            })
        })
    }
}

export const columnasFijas: Column[] = [
    { title: "Nombre", cell: x => ({ data: x.NombreClienteFinal }) },
    { title: "Teléfono", cell: x => ({ data: x.TelefonoClienteFinal }) },
    { title: "Acepta flete por cobrar", cell: x => ({ data: x.ClienteFinalAceptaFXC }) },
    { title: "Tarifa", cell: x => ({ data: x.TarifaClienteFinal }) }
];

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps), ...columnasFijas];
}
/**
* Listado de ClienteDeCliente
*/
class ClienteDeClienteListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    idCliente = (x: Props) => x.idCliente;
    clientesFinales = createSelectorRx(this.idCliente, idCliente => observeResource(resources.ClienteDeCliente.ObtenerClienteFinales, idCliente));
    itemsOrdenados = createSelectorRx(this.clientesFinales, clientesFinales => orderBy(clientesFinales, x => x.NombreClienteFinal));

    onAgregar = async () => {
        var idCliente = this.idCliente(this.props);
        const result = await this.modals.showModal(EditModal, idCliente, []);
        if (result.result) {
            await resources.ClienteDeCliente.Add(idCliente, result.value);
        }
    }

    onEliminar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.NombreClienteFinal);
        if (ok) {
            await resources.ClienteDeCliente.Delete(item.IdRegistro);
        }
    }

    render() {
        const cols = columnas(this);
        const itemsOrdenados = this.itemsOrdenados(this.props);

        return (
            <div>
                <kea.Title titulo="Listado de clientes" onAgregar={this.onAgregar} />

                <kea.Grid2 items={itemsOrdenados} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const ClienteDeClienteList = componentToRx(ClienteDeClienteListNoRx);


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/tabs/clientesfinales/index.tsx